import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './api';


export const fetchDailyOrders = createAsyncThunk(
  'dailyOrders/fetchDailyOrders',
  async (_, { rejectWithValue }) => {
    try {
      
      const response = await api.get(`/api/daily_orders/`);
      return response.data;
    } catch (error) {
      // console.error('Fetch daily orders error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to fetch daily orders.');
    }
  }
);

//by month
export const fetchDailyOrdersByMonth = createAsyncThunk(
  'dailyOrders/fetchDailyOrdersByMonth',
  async ({month, year}, { rejectWithValue }) => {
    try {
      const config = {
        params: {
          month: month,
          year: year,
        },
      };

      // Make the POST request to the new endpoint
      const response = await api.get(`/api/daily_orders/orders-by-month/`, config);
      return response.data;
    } catch (error) {
      // console.error('Fetch daily orders by month error response:', error.response);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch daily orders by month.');
    }
  }
);
//by month
export const fetchDailyOrdersOnlyMonths = createAsyncThunk(
  'dailyOrders/fetchDailyOrdersOnlyMonths',
  async ({month, year}, { rejectWithValue }) => {
    try {
      const config = {
        params: {
          month: month,
          year: year,
        },
      };

      // Make the POST request to the new endpoint
      const response = await api.get(`/api/daily_orders/orders-by-month/`, config);
      return response.data;
    } catch (error) {
      // console.error('Fetch daily orders by month error response:', error.response);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch daily orders by month.');
    }
  }
);


// Δημιουργία του Slice
const dailyOrdersSlice = createSlice({
  name: 'dailyOrders',
  initialState: {
    dailyOrders: [],
    todaysOrder:[],
    isTodayOrder:false,
    status: 'idle',
    error: null,
    getMonthStatus: 'idle',
    getMonthError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyOrders.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDailyOrders.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.dailyOrders = action.payload;
      })
      .addCase(fetchDailyOrders.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch daily orders.';
      })
      .addCase(fetchDailyOrdersByMonth.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDailyOrdersByMonth.fulfilled, (state, action) => {
        const today = new Date().toISOString().split('T')[0]
        state.todaysOrder = action.payload.filter(order => order.date === today);
        state.isTodayOrder = action.payload.some(order => order.date === today);
        state.status = 'succeeded';
        state.dailyOrders = action.payload;
      })
      .addCase(fetchDailyOrdersByMonth.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch daily orders.';
      })
      .addCase(fetchDailyOrdersOnlyMonths.pending, (state) => {
        state.getMonthStatus = 'loading';
      })
      .addCase(fetchDailyOrdersOnlyMonths.fulfilled, (state, action) => {
        state.getMonthStatus = 'succeeded';
        state.dailyOrders = action.payload;
      })
      .addCase(fetchDailyOrdersOnlyMonths.rejected, (state, action) => {
        state.getMonthStatus = 'failed';
        state.dailyOrders = []
        state.getMonthError = action.payload || 'Failed to fetch daily orders.';
      });
  }
});

export default dailyOrdersSlice.reducer;
